var API_BASE_URL = "".concat(process.env.REACT_APP_API_BASE_URL, "/api/v1");
var CUSTOMER_ONBOARDING_MICROSERVICE = process.env.REACT_APP_CUSTOMER_ONBOARDING_BASE_URL || "";
var EVENT_CREATION_MICROSERVICE = process.env.REACT_APP_EVENT_CREATION_BASE_URL || "";
var CUSTOMER_ONBOARDING_API_BASE_URL = "".concat(CUSTOMER_ONBOARDING_MICROSERVICE, "/api/v1");
var EVENT_CREATION_API_BASE_URL = "".concat(EVENT_CREATION_MICROSERVICE, "/api/v1");
var endpoints = {
    web: {
        home: "/",
        login: "/onboarding/welcome",
        profileCompletion: "/onboarding/profile-completion",
        oauthCallback: "/onboarding/oauth/callback",
        profile: "/profile",
        createTrip: "/trip/create",
        tripDetails: "/trip",
        manageTrips: "/manage-trips",
        explore: "/explore",
    },
    api: {
        sendOtp: "".concat(API_BASE_URL, "/auth/send-otp"),
        verifyOtp: "".concat(API_BASE_URL, "/auth/verify-otp"),
        resendOtp: "".concat(API_BASE_URL, "/auth/resend-otp"),
        googleOAuth: "".concat(API_BASE_URL, "/oauth/google"),
        linkedinOAuth: "".concat(API_BASE_URL, "/oauth/linkedin"),
        facebookOAuth: "".concat(API_BASE_URL, "/oauth/facebook"),
        verifyEmailFromMail: "".concat(API_BASE_URL, "/auth/verify-email"),
        updateProfile: "".concat(API_BASE_URL, "/auth/update-profile"),
        profileCompletionStatus: "".concat(API_BASE_URL, "/auth/profile-completion-status"),
        homeToken: "".concat(API_BASE_URL, "/token/validate"),
        refreshToken: "".concat(API_BASE_URL, "/token/refresh"),
        getFilteredTrips: "".concat(API_BASE_URL, "/trip/filtered"),
        getTripDetails: "".concat(API_BASE_URL, "/trip"),
        createTrip: "".concat(API_BASE_URL, "/trip/create"),
        updateTrip: "".concat(API_BASE_URL, "/trip/update"),
        uploadFile: "".concat(API_BASE_URL, "/file/upload"),
        inviteUsersToTrip: "".concat(API_BASE_URL, "/invite"),
        getTripCategories: "".concat(API_BASE_URL, "/trip/categories"),
        tripMembershipAction: "".concat(API_BASE_URL, "/trip/membership/action"),
        manageTrips: {
            getDashboardHeaderData: "".concat(API_BASE_URL, "/manage-trips/getDashboardHeaderData"),
        },
        getUserProfile: "".concat(API_BASE_URL, "/user/profile"),
        getUserMetadata: "".concat(API_BASE_URL, "/user/metadata"),
    },
};
/* export const getUrl = (urlType, withBaseUrl) => {
    const url_splitted = urlType.split(".");
    const url = url_splitted.reduce(() => {

    }, "");
} */
export default endpoints;
